module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Medium.979563d.otf";